export const imageCodes = {
  homeSlider1: {
    code: "${merchantId}_tmpl_img_3",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fasteria%20landing%20page%20banner.png?alt=media&token=6b1e76ea-cc70-4c38-93d9-6620b3101edd",
  },
  homeSlider2: {
    code: "${merchantId}_tmpl_img_4",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fast%20ban%20(1).png?alt=media&token=bc8c1385-a40d-4fe2-bae0-bcfe75a3653c",
  },

  heroProduct1: {
    code: "${merchantId}_tmpl_img_21",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FDSC09367.jpg?alt=media&token=68f01fd3-7c1d-4ad1-b7f0-b6270e109fe1",
  },

  heroProduct2: {
    code: "${merchantId}_tmpl_img_16",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio9.jpg?alt=media&token=f0fc9940-3665-4cc1-9c43-7a9af185812e",
  },

  collection1: {
    code: "${merchantId}_tmpl_img_11",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio6.jpg?alt=media&token=21a087f6-89b6-4336-9803-1398a4d5b694",
  },

  collection2: {
    code: "${merchantId}_tmpl_img_2",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Ffirst.jpg?alt=media&token=0c37c2fe-1f60-4ab2-bad9-bfd492c85471",
  },

  chooseUs: {
    code: "${merchantId}_tmpl_img_1",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fchoose_reason.jpg?alt=media&token=d9b54850-86c7-4475-9b47-3fa9f1aa9780",
  },

  founderCodes: {
    code: "${merchantId}_tmpl_img_7",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Ffounder_sologan.png?alt=media&token=b0602d54-9f38-436e-b569-155bd7e9f345",
  },

  herCo: {
    code: "${merchantId}_tmpl_img_5",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fherco.jpg?alt=media&token=cf688b5d-9919-448c-913b-8df9fdab2b15",
  },

  littleOdd: {
    code: "${merchantId}_tmpl_img_6",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flittleoddstu.png?alt=media&token=a1b431ff-00c6-473a-bd75-2a058d1f2164",
  },

  spex: {
    code: "${merchantId}_tmpl_img_26",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fspex.jpg?alt=media&token=325f3fc8-f8bb-4af3-8151-73e9b11884fe",
  },

  heropg: {
    code: "${merchantId}_tmpl_img_22",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fhero.png?alt=media&token=35dbef78-3eed-4b6f-b91f-b21898f2bd12",
  },

  hanger: {
    code: "${merchantId}_tmpl_img_23",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fhanger.png?alt=media&token=8655b55a-33ee-4280-99cb-4be145f0d0ae",
  },

  newItem: {
    code: "${merchantId}_tmpl_img_24",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FImage%20from%20iOS.jpg?alt=media&token=fef8a12d-8f56-4f71-81a8-7b09c0e70b3b",
  },
};

export const videoCodes = {
  video2: {
    code: "${merchantId}_tmpl_video_2",
    video: "https://www.youtube.com/embed/Xg_CLNeoxAQ",
  },
};

export const textCodes = {
  sologan1: {
    code: "${merchantId}_tmpl_text_3",
    text: "Our only intention is to give every girls excitement and happiness while wearing our designs, because happiest girls are the prettiest.",
  },

  having: {
    code: "${merchantId}_tmpl_text_4",
    text: "Having a great style is to feel good in what you wear...",
  },

  reason1: {
    code: "${merchantId}_tmpl_text_5",
    text: "We keep our customers stay on today's fashion trend. We make sure our customers feel confident with Asteria",
  },

  reason2: {
    code: "${merchantId}_tmpl_text_6",
    text: "Expensive does not mean classy. We give you best quality designs in affordable price.",
  },

  reason3: {
    code: "${merchantId}_tmpl_text_7",
    text: "We care you with heart and make you feel as home.",
  },

  dateSet: {
    code: "${merchantId}_tmpl_text_15",
    text: "Shop Cropped Shirt ───",
  },

  fitBlazer: {
    code: "${merchantId}_tmpl_text_16",
    text: "Shop Champagne Date Set & Timeless Fitted Blazer ───",
  },

  shopNow: {
    code: "${merchantId}_tmpl_text_20",
    text: "shop now",
  },
};

export const titleCodes = {
  category: {
    code: "${merchantId}_tmpl_title_4",
    title: "Product Categories",
  },

  reasonTitle: {
    code: "${merchantId}_tmpl_text_1",
    title: "Reasons Why People Choose Us Always",
  },

  reasonTitle1: {
    code: "${merchantId}_tmpl_title_7",
    title: "Minimal & Stylish Design",
  },

  reasonTitle2: {
    code: "${merchantId}_tmpl_title_8",
    title: "Affordable Price",
  },

  reasonTitle3: {
    code: "${merchantId}_tmpl_title_9",
    title: "Customer Care",
  },

  featureTitle: {
    code: "${merchantId}_tmpl_title_2",
    title: "Featured Products",
  },

  founder1: {
    code: "${merchantId}_tmpl_text_15",
    title: "Co. Founder, Tina Aung",
  },

  collaboration: {
    code: "${merchantId}_tmpl_title_5",
    title: "In Collaboration With",
  },

  newArrival: {
    code: "${merchantId}_tmpl_title_19",
    title: "New Arrival",
  },
};
